export const getStoryblokImage = (
  image: ProductVideoComponent | ProductImageComponent | null | undefined,
): StoryblokImage | null => {
  if (!image) return null;

  if ('image' in image) return image.image;
  if ('coverImage' in image) return image.coverImage;

  return null;
};

export const getBackgroundImage = (product: ProductType) => {
  const secondImage = getStoryblokImage(product.images[1]);

  if (secondImage) return secondImage;

  const firstImage = getStoryblokImage(product.images[0]);

  if (firstImage) return firstImage;

  return null;
};
